import React from 'react';
import {RawMarkupComponent} from '../components/base';
import EditIcon from './edit-icon';
import InfoIcon from './info-icon';
import {MediaManagerController} from './media-manager';
import {ContentRichEditor,MinimalRichEditor, TinyEditable} from './editor';
import {PageBaseComponent} from './page-components';
import JsUtility from '../utils/utility';
import Console from '../console';
import { ScrollComponent } from '../components/components';

////h2 title content editable
export class HeroTitle extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
        else this.title.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.title.innerHTML);
    }

    render(){
        if(this.props.active){
            return(
               <h2 className={this.props.cls} ref={(ref) => this.title = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h2>
            );
        }else{
            return(
              <h2 className={this.props.cls} ref={(ref) => this.title = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h2>
            );
        }
    }
}

////h2 title text content editable
export class H2Title extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
        else this.title.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.title.innerText);
    }

    render(){
        if(this.props.active){
            return(
               <h2 className={this.props.cls} ref={(ref) => this.title = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h2>
            );
        }else{
            return(
              <h2 className={this.props.cls} ref={(ref) => this.title = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h2>
            );
        }
    }
}

////h3 title content editable
export class H3Title extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
        else this.title.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.title.innerText);
    }

    render(){
        if(this.props.active){
            return(
               <h3 className={this.props.cls} ref={(ref) => this.title = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h3>
            );
        }else{
            return(
              <h3 className={this.props.cls} ref={(ref) => this.title = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h3>
            );
        }
    }
}

///h4 title content editable
export class H4Title extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
        else this.title.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.title.innerText);
    }

    render(){
        if(this.props.active){
            return(
               <h4 className={this.props.cls} ref={(ref) => this.title = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h4>
            );
        }else{
            return(
              <h4 className={this.props.cls} ref={(ref) => this.title = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h4>
            );
        }
    }
}

///h5 title content editable
export class H5Title extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.title.setAttribute('contenteditable',true);
        else this.title.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.title.innerText);
    }

    render(){
        if(this.props.active){
            return(
               <h5 className={this.props.cls} ref={(ref) => this.title = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h5>
            );
        }else{
            return(
              <h5 className={this.props.cls} ref={(ref) => this.title = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h5>
            );
        }
    }
}

export class H1Title extends RawMarkupComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (this.props.active) this.title.setAttribute('contenteditable', true);
    }

    componentDidUpdate() {
        if (this.props.active) this.title.setAttribute('contenteditable', true);
        else this.title.removeAttribute('contenteditable');
    }

    onChange(event) {
        if (this.props.onChange) this.props.onChange(this.title.innerText);
    }

    render() {
        if (this.props.active) {
            return (
                <h1 className={this.props.cls} ref={(ref) => this.title = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h1>
            );
        } else {
            return (
                <h1 className={this.props.cls} ref={(ref) => this.title = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.title)}></h1>
            );
        }
    }
}

///span content editable
export class SpanText extends RawMarkupComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (this.props.active) this.span.setAttribute('contenteditable', true);
    }

    componentDidUpdate() {
        if (this.props.active) this.span.setAttribute('contenteditable', true);
        else this.span.removeAttribute('contenteditable');
    }

    onChange(event) {
        if (this.props.onChange) this.props.onChange(this.span.innerText);
    }

    render() {
        if (this.props.active) {
            return (
                <span className={this.props.cls} ref={(ref) => this.span = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.text)}></span>
            );
        } else {
            return (
                <span className={this.props.cls} ref={(ref) => this.span = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.text)}></span>
            );
        }
    }
}

///h5 title content editable
export class BlockQuotation extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.quote.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.quote.setAttribute('contenteditable',true);
        else this.quote.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.quote.innerHTML);
    }

    getContent(){
        return this.quote.innerHTML;
    }

    render(){
        if(this.props.active){
            return(
               <blockquote className={this.props.cls} ref={(ref) => this.quote = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.quote)} />
            );
        }else{
            return(
              <blockquote className={this.props.cls} ref={(ref) => this.quote = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.quote)} />
            );
        }
    }
}

///unordered list content editable
export class ListEditor extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.list.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.list.setAttribute('contenteditable',true);
        else this.list.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) this.props.onChange(this.list.innerHTML);
    }

    render(){
        if(this.props.active){
            return(
               <ul className={this.props.cls} ref={(ref) => this.list = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.items)}></ul>
            );
        }else{
            return(
              <ul className={this.props.cls} ref={(ref) => this.list = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.items)}></ul>
            );
        }
    }
}

///linkable image
export class ImageLink  extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount(){
    
    }

    onFilesCancel(){
        
    }

    onClick(event){
        var link=this.props.media.link;
        var newTarget=this.props.media.newTarget;
        if(link && newTarget) {
            window.open(link);
        }else{
            location.href=link;
        }
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.props.media]);
    }

    render(){
        var src=this.props.media.url;
        if(this.props.width) src+='?width=' + this.props.width;
        var cls='relative';
        if(this.props.cls) cls+=' ' + this.props.cls;
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        return(
            <div className={cls}>
              <img src={src} onClick={this.onClick.bind(this)}/>
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.props.active}>
                 <MediaManagerController
                    postUrl={postUrl} 
                    data={this.props.mediaManagerData} 
                    ref={(ref) => this.mediaController = ref} 
                    onFilesSelected={this.props.onFilesSelected} 
                    onCancel={this.onFilesCancel.bind(this)} 
                  />
              </EditIcon>
            </div>
        );
    }
}

export class Image extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {

    }

    onFilesCancel() {

    }

    onEditClick(event) {
        this.mediaController.mode = 'select';
        this.mediaController.show([this.props.media]);
    }

    get Image(){
        return this.image;
    }

    render() {
        var src = this.props.media.url;
        if (this.props.width) src += '?width=' + this.props.width;
        var cls = 'relative';
        if (this.props.cls) cls += ' ' + this.props.cls;
        var postUrl = '/api/MediaFile';
        if (this.props.postUrl) postUrl = this.props.postUrl;
        var imgCss=this.props.imgCss;
        return (
            <div className={cls}>
                <img src={src} className={imgCss} ref={(ref) => this.image = ref} />
                <EditIcon onClick={this.onEditClick.bind(this)} active={this.props.active}>
                    <MediaManagerController
                        postUrl={postUrl}
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.props.onFilesSelected}
                        onCancel={this.onFilesCancel.bind(this)}
                    />
                </EditIcon>
            </div>
        );
    }
}

export class MultiSlideCarousel extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.prevNav.classList.remove('disabled');
        this.nextNav.classList.remove('disabled');

    }

    render() {
        var cls = this.props.cls;
        if (!cls) cls = '';
        var width = '23000px';
        if (this.props.width) {
            width = `${this.props.width}px`;
        }
        var style = {
            width: width
        };
        return (
            <ui-carousel animation="multi-slide" class={cls}>
                <carousel-navigation class="prev" ref={(ref) => this.prevNav = ref} ></carousel-navigation>
                <carousel-navigation class="next nav-visible" ref={(ref) => this.nextNav = ref} ></carousel-navigation>
                <carousel-navigation class="indicators"></carousel-navigation>
                <carousel-inner-container class="visible multi-border">
                    <carousel-items style={style}>
                        {this.props.children}
                    </carousel-items>
                </carousel-inner-container>
            </ui-carousel>
        );
    }
}

export class HeaderTitleComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
            <header className={cls}>
                <H3Title 
                   active={this.state.component.active} 
                   title={this.state.component.content.title} 
                   onChange={this.onTitleChange.bind(this)}
                />
            </header>
        );
    }
}

export class HeroTitleComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
           <HeroTitle 
              active={this.state.component.active} 
              title={this.state.component.content.title} 
              onChange={this.onTitleChange.bind(this)} 
              cls={cls}
           />  
        );
    }
}

export class H2TitleComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    onTitleChange(title) {
        this.state.component.content.title = title;
        this.setState(this.state.component);
    }

    render() {
        var cls = this.props.cssClass;
        return (
            <H2Title
                active={this.state.component.active}
                title={this.state.component.content.title}
                onChange={this.onTitleChange.bind(this)}
                cls={cls}
            />
        );
    }
}

export class H3TitleComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
           <H3Title 
              active={this.state.component.active} 
              title={this.state.component.content.title} 
              onChange={this.onTitleChange.bind(this)} 
              cls={cls}
           />  
        );
    }
}

export class H4TitleComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
           <H4Title 
              active={this.state.component.active} 
              title={this.state.component.content.title} 
              onChange={this.onTitleChange.bind(this)} 
              cls={cls}
           />  
        );
    }
}

export class H5TitleComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
           <H5Title 
              active={this.state.component.active} 
              title={this.state.component.content.title} 
              onChange={this.onTitleChange.bind(this)} 
              cls={cls}
           />  
        );
    }
}

export class SpanTextComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    onTextChange(text) {
        this.state.component.content.text = text;
        this.setState(this.state.component);
    }

    render() {
        var cls = this.props.cssClass;
        return (
            <SpanText
                active={this.state.component.active}
                text={this.state.component.content.text}
                onChange={this.onTextChange.bind(this)}
                cls={cls}
            />
        );
    }
}

export class HeroComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files[0];
        this.setState(this.state.component);
    }

    onFilesCancel(){
        
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.state.component.content.media]);
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    render(){
        var src=this.state.component.content.media.url;
        src+='?width=1600';
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
            <section className="image-stretch-container">
              <img src={src}/>
              <HeroTitle 
                 active={this.state.component.active} 
                 title={this.state.component.content.title} 
                 onChange={this.onTitleChange.bind(this)} 
                 cls={this.props.cssClass} 
              />
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                 <MediaManagerController
                    postUrl={postUrl}
                    data={this.props.mediaManagerData} 
                    ref={(ref) => this.mediaController = ref} 
                    onFilesSelected={this.onFilesSelected.bind(this)} 
                    onCancel={this.onFilesCancel.bind(this)} 
                  />
              </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </section>
        );
    }
}

export class HeroPictureComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files[0];
        this.setState(this.state.component);
    }

    onFilesCancel(){
        
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.state.component.content.media]);
    }

    render(){
        var src=this.state.component.content.media.url;
        // "No image set" detection: PageBaseComponent's updateMediaUrls
        // rewrites every MediaEntity url as mediaFileBaseUrl + name, so
        // an EMPTY media name yields the bare base URL (ends in '/'),
        // not an empty string. A real image URL never ends in '/'.
        var hasImage = !!(src && !src.endsWith('/'));
        // No image + edit mode OFF → render nothing. Prevents the
        // browser's broken-image icon on pages whose hero hasn't been
        // populated yet (e.g. an admin browsing in non-edit mode). The
        // CMS toolbar's edit toggle sets `active`, which re-renders the
        // (empty) component with its edit icon so the admin can pick an
        // image via the media manager.
        if(!hasImage && !this.state.component.active){
            return null;
        }
        var mobileSrc=JsUtility.toMobileUrl(src);
        var cls='image-stretch-container';
        if(this.props.cssClass){
            cls+=' ' + this.props.cssClass;
        }
        // Empty-but-active: keep a visible placeholder area so the edit
        // icon has somewhere to live (the section min-height comes from
        // the container CSS; the <picture> is skipped below via src='').
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        let mediaWidth=640;
        if(this.props.mediaWidth){
            mediaWidth = parseInt(this.props.mediaWidth);
        }
        let minWidth=mediaWidth + 1;
        // In edit mode with no image yet, skip the <picture> (an <img>
        // with empty src shows the broken icon) and render a bare spacer
        // so the edit icon has a click target. Deliberately unlabeled —
        // this branch is only reachable in edit mode, but no user-facing
        // copy belongs in it regardless.
        return(
            <section className={cls}>
              {hasImage ? (
                <picture>
                  <source media={`(min-width: ${minWidth}px)`} srcSet={src} />
                  <source media={`(max-width: ${mediaWidth}px)`} srcSet={mobileSrc} />
                  <img src={src} />
                </picture>
              ) : (
                <div style={{minHeight:'96px'}}></div>
              )}
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                 <MediaManagerController
                    postUrl={postUrl}
                    data={this.props.mediaManagerData}
                    ref={(ref) => this.mediaController = ref}
                    onFilesSelected={this.onFilesSelected.bind(this)}
                    onCancel={this.onFilesCancel.bind(this)}
                  />
              </EditIcon>
              {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader}/>}
            </section>
        );
    }
}

export class HeroPictureTitleComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onFilesSelected=(files)=>{
        this.state.component.content.media = files[0];
        this.setState(this.state.component);
    }

    onFilesCancel=()=>{

    }

    onEditClick=(event)=>{
        this.mediaController.mode = 'select';
        this.mediaController.show([this.state.component.content.media]);
    }

    onTitleChange=(title)=>{
        this.state.component.content.title = title;
        this.setState(this.state.component);
    }

    render() {
        var src = this.state.component.content.media.url;
        var mobileSrc = JsUtility.toMobileUrl(src);
        src+='?width=1920';
        if(!this.props.disableMobileResize){
            mobileSrc += '?width=640';
        }
       
        var cls = 'image-stretch-container';
        if (this.props.cssClass) {
            cls += ' ' + this.props.cssClass;
        }
        var postUrl = '/api/MediaFile';
        if (this.props.postUrl) postUrl = this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return (
            <section className={cls}>
                <picture>
                    <source media="(min-width: 641px)" srcSet={src} />
                    <source media="(max-width: 640px)" srcSet={mobileSrc} />
                    <img src={src} />
                </picture>
                <HeroTitle
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange}
                    cls={this.props.cssClass}
                />
                <EditIcon onClick={this.onEditClick} active={this.state.component.active} cls={this.props.iconCss}>
                    <MediaManagerController
                        postUrl={postUrl}
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.onFilesSelected}
                        onCancel={this.onFilesCancel}
                    />
                </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </section>
        );
    }
}

export class HeroImageComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files[0];
        this.setState(this.state.component);
    }

    onFilesCancel(){
        
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.state.component.content.media]);
    }

    render(){
        var src=this.state.component.content.media.url;
        var cls='image-stretch-container';
        if(this.props.css){
            cls+=' ' + this.props.cssClass;
        }
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
            <section className={cls}>
              <img src={src} />
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                 <MediaManagerController
                    postUrl={postUrl} 
                    data={this.props.mediaManagerData} 
                    ref={(ref) => this.mediaController = ref} 
                    onFilesSelected={this.onFilesSelected.bind(this)} 
                    onCancel={this.onFilesCancel.bind(this)} 
                  />
              </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </section>
        );
    }
}

export class HeroPictureLinkComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files[0];
        this.setState(this.state.component);
    }

    onFilesCancel(){
        
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.state.component.content.media]);
    }

    onClick(event){
        var link=this.state.component.content.media.link;
        var newTarget=this.state.component.content.media.newTarget;
        if(link && newTarget){
            window.open(link);
        }else{
            location.href=link;
        }
    }

    render(){
        var src=this.state.component.content.media.url;
        var mobileSrc=JsUtility.toMobileUrl(src);
        var cls='image-stretch-container pointer';
        if(this.props.cssClass){
            cls+=' ' + this.props.css;
        }
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
            <section className={cls} >
              <picture>
                <source media="(min-width: 641px)" srcSet={src} />
                <source media="(max-width: 640px)" srcSet={mobileSrc} />
                    <img src={src} onClick={this.onClick.bind(this)} />
              </picture> 
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                 <MediaManagerController
                    postUrl={postUrl} 
                    data={this.props.mediaManagerData} 
                    ref={(ref) => this.mediaController = ref} 
                    onFilesSelected={this.onFilesSelected.bind(this)} 
                    onCancel={this.onFilesCancel.bind(this)} 
                  />
              </EditIcon>
             {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </section>
        );
    }
}

export class HeroImageLinkComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files[0];
        this.setState(this.state.component);
    }

    onFilesCancel(){
        
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.state.component.content.media]);
    }

    onClick(event){
        var link=this.state.component.content.media.link;
        var newTarget=this.state.component.content.media.newTarget;
        if(link && newTarget){
            window.open(link);
        }else{
            location.href=link;
        }
    }

    render(){
        var src=this.state.component.content.media.url;
        var cls='image-stretch-container pointer';
        if(this.props.cssClass){
            cls+=' ' + this.props.css;
        }
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
            <section className={cls} onClick={this.onClick.bind(this)}>
              <img src={src} />
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                 <MediaManagerController
                    postUrl={postUrl} 
                    data={this.props.mediaManagerData} 
                    ref={(ref) => this.mediaController = ref} 
                    onFilesSelected={this.onFilesSelected.bind(this)} 
                    onCancel={this.onFilesCancel.bind(this)} 
                  />
              </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </section>
        );
    }
}

export class ImageComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files[0];
        this.setState(this.state.component);
    }

    onFilesCancel(){
        
    }

    onClick(event){
        var link=this.state.component.content.media.link;
        var newTarget=this.state.component.content.media.newTarget;
        if(link && newTarget) window.open(link);
        else if(link) location.href=link;
    }

    onEditClick(event){
        this.mediaController.mode='select';
        this.mediaController.show([this.state.component.content.media]);
    }

    render(){
        var src=this.state.component.content.media.url;
        var link=this.state.component.content.media.link;
        var imgCls='';
        if(link) imgCls='pointer';
        if(this.props.width) src+='?width=' + this.props.width;
        var cls='relative';
        if(this.props.cssClass) cls+=' ' + this.props.cssClass;
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
            <div className={cls}>
              <img src={src} onClick={this.onClick.bind(this)} className={imgCls}/>
              <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                 <MediaManagerController
                    postUrl={postUrl} 
                    data={this.props.mediaManagerData} 
                    ref={(ref) => this.mediaController = ref} 
                    onFilesSelected={this.onFilesSelected.bind(this)} 
                    onCancel={this.onFilesCancel.bind(this)} 
                  />
              </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </div>
        );
    }
}

export class HtmlEditorComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onEditorChange(html){
        this.state.component.content.body=html;
        this.setState(this.state.component);
    }

    onGetContent(data){
        data.content.body=this.editor.getContent();
        return data;
    }

    render(){
        var cls=this.props.cssClass;
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
            <ContentRichEditor 
               filePostUrl={postUrl} 
               content={this.state.component.content.body} 
               active={this.state.component.active} 
               mediaManagerData={this.props.mediaManagerData} 
               customFormats={this.props.customFormats}
               ref={(ref) => this.editor = ref} 
               cls={cls}
            />
        );
    }
}

export class HeaderListComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    onEditorChange(items){
        this.state.component.content.items=items;
        this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
            <div className={cls}>
                <H4Title 
                   active={this.state.component.active} 
                   title={this.state.component.content.title} 
                   onChange={this.onTitleChange.bind(this)}
                />
                <ListEditor 
                   active={this.state.component.active} 
                   items={this.state.component.content.items} 
                   onChange={this.onEditorChange.bind(this)} 
                   cls={this.props.cssClass}
                />
            </div>
        );
    }
}

export class HeroTitleListComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    onEditorChange(items){
        this.state.component.content.items=items;
        this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
            <div className={cls}>
                <H2Title 
                   active={this.state.component.active} 
                   title={this.state.component.content.title} 
                   onChange={this.onTitleChange.bind(this)}
                />
                <ListEditor 
                   active={this.state.component.active} 
                   items={this.state.component.content.items} 
                   onChange={this.onEditorChange.bind(this)} 
                   cls={this.props.listCssClass}
                />
            </div>
        );
    }
}

export class EditorListComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onEditorChange(items){
        this.state.component.content.items=items;
        this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
            <ListEditor 
               active={this.state.component.active} 
               items={this.state.component.content.items} 
               onChange={this.onEditorChange.bind(this)} 
               cls={this.props.cssClass}
            />
        );
    }
}

export class TinyEditorComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onGetContent(data){
        var content=this.editor.getContent();
        if(!data.content) data.content={};
        data.content.html=content;
        return data;
    }

    render(){
        var cls=this.props.cssClass;
        return(
              <TinyRichEditor 
                addColors='#4C3520,#93965F' 
                content={this.state.component.content.html} 
                active={this.state.component.active} 
                cls={cls}
                disableSticky={true} 
                ref={(ref) => this.editor = ref} 
              />
        );
    }
}

export class MinimalEditorComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onGetContent(data){
        var content=this.editor.getContent();
        if(!data.content) data.content={};
        data.content.html=content;
        return data;
    }

    render(){
        var cls=this.props.cssClass;
        return(
              <MinimalRichEditor 
                content={this.state.component.content.html} 
                active={this.state.component.active} 
                disableSticky={true} 
                cls={cls} 
                addColors='#8f8f8f,#666666' 
                ref={(ref) => this.editor = ref} 
              /> 
        );
    }
}

export class ContentEditableComponent  extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onGetContent(data){
        data.content.html=this.editor.getContent();
        return data;
    }

    render(){
        var cls=this.props.cssClass;
        return(
              <TinyEditable
                content={this.state.component.content.html} 
                active={this.state.component.active} 
                cls={cls}
                ref={(ref) => this.editor = ref} 
              />
        );
    }
}

export class TitleContentEditableComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    onEditorChange(html){
        this.state.component.content.html=html;
        this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        return(
            <div className={cls}>
                <H2Title 
                   active={this.state.component.active} 
                   title={this.state.component.content.title} 
                   onChange={this.onTitleChange.bind(this)}
                />
                <TinyEditable
                   active={this.state.component.active} 
                   content={this.state.component.content.html} 
                   onChange={this.onEditorChange.bind(this)} 
                   cls={this.props.editorCss}
                />
            </div>
        );
    }
}

export class TitleTinyEditorComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onTitleChange(title){
       this.state.component.content.title=title;
       this.setState(this.state.component);
    }

    onGetContent(data){
        data.content.html=this.editor.getContent();
        return data;
    }

    render(){
        var cls=this.props.cssClass;
        return(
            <div className={cls}>
                <H2Title 
                   active={this.state.component.active} 
                   title={this.state.component.content.title} 
                   onChange={this.onTitleChange.bind(this)}
                />
                <TinyRichEditor 
                  addColors='#a6978a' 
                  content={this.state.component.content.html} 
                  active={this.state.component.active} 
                  cls={cls}
                  disableSticky={true} 
                  ref={(ref) => this.editor = ref} 
                />
            </div>
        );
    }
}

export class BlockQuoteComponent extends PageBaseComponent{
    constructor(props){
        super(props)
    }

    onQuoteChange(quote){
       this.state.component.content=quote;
       this.setState(this.state.component);
    }

    render(){
        var cls=this.props.cssClass;
        console.log(this.state.component.content);
        return(
           <BlockQuotation
              active={this.state.component.active} 
              quote={this.state.component.content} 
              onChange={this.onQuoteChange.bind(this)} 
              cls={cls}
           />  
        );
    }
}

export class HTitleComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    onTitleChange(title) {
        this.state.component.content.title = title;
        this.setState(this.state.component);
    }

    render() {
        var cls = this.props.cssClass;
        var type=this.props.type;
        if(!type){
            type='h2';
        }
        if(type==='h5'){
            return (
                <H5Title
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange.bind(this)}
                    cls={cls}
                />
            );

        }else if(type==='h4'){
            return (
                <H4Title
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange.bind(this)}
                    cls={cls}
                />
            );
        }else if(type==='h3'){
            return (
                <H3Title
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange.bind(this)}
                    cls={cls}
                />
            );
        }else if(type==='h2'){
            return (
                <H2Title
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange.bind(this)}
                    cls={cls}
                />
            );
        }else if(type==='h1'){
            return (
                <H1Title
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange.bind(this)}
                    cls={cls}
                />
            );
        }else{
            return (
                <H2Title
                    active={this.state.component.active}
                    title={this.state.component.content.title}
                    onChange={this.onTitleChange.bind(this)}
                    cls={cls}
                />
            );
        }
    }
}

export class DownArrow extends ScrollComponent {
    constructor(props) {
        super(props)
    }

    onScroll = (y) => {
        this.props.onScroll(y);
    }
  

    render() {
        return (
            <div className="down-arrow-container" onClick={this.props.onClick}>
                <img src="/icons/down-arrow.svg" />
            </div>
        );
    }
}

export class VideoComponent extends PageBaseComponent {
    constructor(props){
        super(props)
        this.icons = {
            sound: 'hide',
            mute: null,
            play: 'hide',
            pause: null
        };
    }

    componentDidMount(){
        super.componentDidMount();
        this.setNativeVideoControls();
        this.video.play();
    }

    componentDidUpdate(){
        if (this.state.component.active){
            var video = this.video;
            video.pause();
            this.play.classList.remove('hide');
            this.pause.classList.add('hide');
            this.icons.pause = 'hide';
            this.icons.play = null;
        }
    }

    setNativeVideoControls = () => {
        if (this.isTouch) {
            var video = this.video;
            video.setAttribute("controls", "controls");
        }
    }

    onEditClick=(event)=>{
        this.mediaController.mode = 'select';
        this.mediaController.show([this.state.component.content.media]);
    }

    onFilesSelected=(files)=>{
        this.state.component.content.media = files[0];
        this.setState(this.state.component);
    }

    onFilesCancel=()=>{

    }

    onSound=(event)=>{
        var video=this.video;
        video.muted = !video.muted;
        this.icons.mute=null;
        this.icons.sound='hide';
        this.mute.classList.remove('hide');
        this.sound.classList.add('hide');
    }

    onMute = (event) => {
        var video = this.video;
        video.muted = !video.muted;
        this.icons.mute = 'hide';
        this.icons.sound = null;
        this.mute.classList.add('hide');
        this.sound.classList.remove('hide');
    }

    onPlay = (event) => {
        var video = this.video;
        video.play();
        this.play.classList.add('hide');
        this.pause.classList.remove('hide');
        this.icons.pause = null;
        this.icons.play = 'hide';
    }

    onPause=(event)=>{
        var video = this.video;
        video.pause();
        this.play.classList.remove('hide');
        this.pause.classList.add('hide');
        this.icons.pause = 'hide';
        this.icons.play = null;
    }

    render(){
        var cls = 'relative';
        if (this.props.cssClass) cls += ' ' + this.props.cssClass;
        var postUrl = '/api/MediaFile';
        if (this.props.postUrl) postUrl = this.props.postUrl;
        var src = this.state.component.content.media.url;
        var mIconClass ='material-icons large-icon';
        var soundIconClass=mIconClass;
        var muteIconClass=mIconClass;
        var playIconClass=mIconClass;
        var pauseIconClass=mIconClass;
        var icons=this.icons;
        if(icons.sound){
            soundIconClass+=' hide';
        }
        if (icons.mute) {
            muteIconClass += ' hide';
        }
        if (icons.play) {
            playIconClass += ' hide';
        }
        if (icons.pause) {
            pauseIconClass += ' hide';
        }
        this.updateMediaUrls(this.props.mediaManagerData);
        return(
           <div className={cls}>
                <video muted loop ref={(ref) => this.video = ref}>
                    <source src={src} type="video/mp4"/>
                </video>
                <div className="component-video-controls">
                    <span className={soundIconClass} ref={(ref) => this.sound = ref} onClick={this.onSound}>volume_mute</span>
                    <span className={muteIconClass} ref={(ref) => this.mute = ref} onClick={this.onMute}>volume_off</span>
                    <span className={playIconClass} ref={(ref) => this.play = ref} onClick={this.onPlay}>play_arrow</span>
                    <span className={pauseIconClass} ref={(ref) => this.pause = ref} onClick={this.onPause}>pause</span>
                </div>
                <EditIcon onClick={this.onEditClick} active={this.state.component.active} cls={this.props.iconCss}>
                    <MediaManagerController
                        postUrl={postUrl}
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.onFilesSelected}
                        onCancel={this.onFilesCancel}
                    />
                </EditIcon>
           </div>
        );
    }
}

export class MultiSlideCarouselComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
        
    }

    onFilesSelected(files) {
        this.state.component.content.media = files;
        this.setState(this.state.component);
    }

    onFilesCancel() {

    }

    onEditClick(event) {
        this.mediaController.mode = 'multi-select';
        this.mediaController.show(this.state.component.content.media);
    }

    getNodes() {

    }

    render() {
        var nodes = this.getNodes();
        this.updateMediaUrls(this.props.mediaManagerData);
        return (
            <div className="relative">
                <MultiSlideCarousel cls={this.props.cssClass}>
                    {nodes}
                </MultiSlideCarousel>
                <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active}>
                    <MediaManagerController
                        postUrl='/api/MediaFile'
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.onFilesSelected.bind(this)}
                        onCancel={this.onFilesCancel.bind(this)}
                    />
                </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </div>
        );
    }
}

export default{
    HeroTitle,
    H2Title,
    H3Title,
    H4Title,
    H5Title,
    H1Title,
    SpanText,
    BlockQuotation,
    ListEditor,
    ImageLink,
    Image,
    HeaderTitleComponent,
    HeroTitleComponent,
    H2TitleComponent,
    H3TitleComponent,
    H4TitleComponent,
    H5TitleComponent,
    SpanTextComponent,
    HTitleComponent,
    HeroComponent,
    HeroPictureComponent,
    HeroPictureTitleComponent,
    HeroImageComponent, 
    HeroPictureLinkComponent,
    HeroImageLinkComponent,
    ImageComponent,
    HtmlEditorComponent,
    HeaderListComponent,
    HeroTitleListComponent,
    EditorListComponent,
    TinyEditorComponent,
    MinimalEditorComponent,
    ContentEditableComponent,
    TitleContentEditableComponent,
    TitleTinyEditorComponent,
    BlockQuoteComponent,
    DownArrow,
    VideoComponent,
    MultiSlideCarouselComponent
}
